import {
    CardItem,
    isPublicationCardItem,
    isPublicationCardItemWithVideo,
} from '@news-mono/web-common'
import { VideoMetaDTO } from '@west-australian-newspapers/publication-types'

export function mapTopVideoMeta(cards: CardItem[]): VideoMetaDTO[] {
    const data = cards.map((item) => {
        if (
            isPublicationCardItem(item) &&
            isPublicationCardItemWithVideo(item)
        ) {
            const crop916 = item.image?.crops?.['9:16']
            const crop169 = item.image?.crops?.['16:9']
            const original = item.image?.crops?.original

            // Selects the most appropriate crop; original is used only when no valid cropped variant exists.
            const rawCrop = crop916 || crop169 || original

            const crop = rawCrop && typeof rawCrop === 'object' ? rawCrop : null

            return {
                id: item.video.id,
                accountId: item.video.accountId,
                source: item.video.source || null,
                sourceExtra: null,
                duration: Number(item.video.duration),
                name: item.video.heading,
                description: item.teaser,
                longDescription: item.teaser,
                byline: null,
                producer: [],
                posterImage: crop
                    ? {
                          reference: crop.reference || '',
                          src: crop.reference || '',
                          width: crop.width || 0,
                          height: crop.height || 0,
                          dimensions: `${crop.width || 0}x${crop.height || 0}`,
                          ratio: crop916
                              ? '9:16'
                              : crop169
                              ? '16:9'
                              : `${crop.width}:${crop.height}`,
                          format: '',
                      }
                    : null,
                primaryTopic: item.primaryTopic.title,
                secondaryTopics:
                    item.secondaryTopics.length > 0
                        ? item.secondaryTopics.map((item) => item.id)
                        : [''],
                videoType: item.video.videoType,
                videoContentType: null,
                seriesInfo: null,
                expiryDate: null,
                publicationDate: item.publicationDate || '',
                topicMeta: {
                    id: item.primaryTopic.id,
                    title: item.primaryTopic.title,
                    metadata: item.primaryTopic.metadata,
                    seoTitle: item.primaryTopic.seoTitle,
                    seoDescription: item.primaryTopic.seoDescription || '',
                    parent: {
                        id: item.primaryTopic.parent?.id || '',
                        title: item.primaryTopic.parent?.title || '',
                        metadata: item.primaryTopic.parent?.metadata || {},
                        seoTitle: item.primaryTopic.parent?.seoTitle || '',
                        seoDescription:
                            item.primaryTopic.parent?.seoDescription || '',
                    },
                },
            }
        }
    })

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return data
}
